import { Status, StatusType } from "@brexhq/component-library";
import React from "react";

import { ModuleThemeType, isDarkTheme } from "@brexhq/shared/types/ModuleTheme";

import { DarkModeOverride } from "../../../contexts/Theme";

export const ArticleTag: React.FC<{
  name: string;
  type?: "tag" | "category";
  theme: ModuleThemeType;
}> = ({ name, theme }) => {
  return (
    <DarkModeOverride useDarkMode={isDarkTheme(theme)}>
      <Status label={name} status={StatusType.NEUTRAL} as="span" />
    </DarkModeOverride>
  );
};
